<ion-content>
  <ion-grid style="margin: 3px">
    <!-- Header -->
    <ion-row>
      <ion-col>
        <ion-card>
          <ion-card-header>
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <div>
                <ion-card-title>Knowledge Gap Detection</ion-card-title>
                <ion-card-subtitle *ngIf="selectedTenant">
                  {{ selectedTenant.name }} ({{ selectedTenant.id }})
                </ion-card-subtitle>
              </div>
              <div style="display: flex; gap: 0.5rem">
                <ion-button
                  fill="solid"
                  color="primary"
                  size="small"
                  (click)="triggerAnalysis()"
                  [disabled]="isLoading"
                >
                  <ion-icon name="play" slot="start"></ion-icon>
                  Trigger Analysis
                </ion-button>
                <ion-button
                  fill="outline"
                  color="danger"
                  size="small"
                  (click)="resetData()"
                  [disabled]="isLoading"
                >
                  <ion-icon name="trash" slot="start"></ion-icon>
                  Reset Data
                </ion-button>
                <ion-button fill="outline" size="small" (click)="onRefresh()">
                  <ion-icon name="refresh" slot="start"></ion-icon>
                  Refresh
                </ion-button>
                <ion-button
                  fill="clear"
                  size="small"
                  (click)="goBackToTenantSelection()"
                >
                  <ion-icon name="arrow-back" slot="start"></ion-icon>
                  Back to Tenants
                </ion-button>
              </div>
            </div>
          </ion-card-header>
        </ion-card>
      </ion-col>
    </ion-row>

    <!-- Tabs -->
    <ion-row>
      <ion-col>
        <ion-segment
          [(ngModel)]="currentTab"
          (ionChange)="switchTab($event.detail.value)"
        >
          <ion-segment-button value="recommendations">
            <ion-label>Recommendations</ion-label>
            <ion-badge *ngIf="recommendationsStats?.active" color="primary">
              {{ recommendationsStats.active }}
            </ion-badge>
          </ion-segment-button>
          <ion-segment-button value="insights">
            <ion-label>Insights</ion-label>
            <ion-badge *ngIf="stats?.total" color="secondary">
              {{ stats.total }}
            </ion-badge>
          </ion-segment-button>
        </ion-segment>
      </ion-col>
    </ion-row>

    <!-- Recommendations Statistics Dashboard -->
    <ion-row *ngIf="recommendationsStats && currentTab === 'recommendations'">
      <ion-col>
        <ion-card>
          <ion-card-header>
            <ion-card-title>Recommendations Analytics</ion-card-title>
          </ion-card-header>
          <ion-card-content>
            <!-- Overview Stats -->
            <div class="stats-grid">
              <div class="stat-card">
                <h2>{{ recommendationsStats.total }}</h2>
                <p>Total Recommendations</p>
              </div>

              <div class="stat-card">
                <h2>{{ recommendationsStats.active }}</h2>
                <p>Active</p>
                <ion-text color="success">
                  <small>Ready for action</small>
                </ion-text>
              </div>

              <div class="stat-card">
                <h2>{{ recommendationsStats.createCount }}</h2>
                <p>Create New</p>
                <ion-text color="success">
                  <small>New articles</small>
                </ion-text>
              </div>

              <div class="stat-card">
                <h2>{{ recommendationsStats.updateCount }}</h2>
                <p>Update Existing</p>
                <ion-text color="warning">
                  <small>Enhance articles</small>
                </ion-text>
              </div>
            </div>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>

    <!-- Insights Statistics Dashboard -->
    <ion-row *ngIf="stats && currentTab === 'insights'">
      <ion-col>
        <ion-card>
          <ion-card-header>
            <ion-card-title>Insights Analytics</ion-card-title>
          </ion-card-header>
          <ion-card-content>
            <!-- Overview Stats -->
            <div class="stats-grid">
              <div class="stat-card">
                <h2>{{ stats.total }}</h2>
                <p>Total Insights</p>
              </div>

              <div class="stat-card">
                <h2>{{ getCategoryNames().length }}</h2>
                <p>Categories</p>
                <ion-text color="primary">
                  <small>Topics covered</small>
                </ion-text>
              </div>
            </div>

            <!-- Category Breakdown -->
            <div
              class="categories-section"
              *ngIf="getCategoryNames().length > 0"
            >
              <h4>By Category</h4>
              <div class="category-list">
                <div
                  *ngFor="let category of getCategoryNames()"
                  class="category-item"
                  [class.selected]="selectedCategory === category"
                  (click)="selectedCategory = category; applyFilters()"
                >
                  <span>{{ category }}</span>
                  <ion-badge>{{
                    stats?.byCategory?.[category] || 0
                  }}</ion-badge>
                </div>
              </div>
            </div>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>

    <!-- Filters -->
    <ion-row *ngIf="currentTab === 'insights'">
      <ion-col>
        <ion-card>
          <ion-card-content>
            <div
              class="filters-container"
              *ngIf="getCategoryNames().length > 0"
            >
              <h5>Filters</h5>
              <div class="filter-controls">
                <ion-item>
                  <ion-label>Category</ion-label>
                  <ion-select
                    [(ngModel)]="selectedCategory"
                    (ionChange)="applyFilters()"
                    placeholder="All Categories"
                  >
                    <ion-select-option
                      *ngFor="let category of getCategoryNames()"
                      [value]="category"
                    >
                      {{ category }}
                    </ion-select-option>
                  </ion-select>
                </ion-item>

                <ion-button
                  fill="clear"
                  size="small"
                  (click)="clearFilters()"
                  *ngIf="selectedCategory"
                >
                  <ion-icon name="close-circle" slot="start"></ion-icon>
                  Clear Filters
                </ion-button>
              </div>
            </div>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>

    <!-- Recommendations List -->
    <ion-row *ngIf="currentTab === 'recommendations'">
      <ion-col>
        <ion-card>
          <ion-card-header>
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <ion-card-title>Recommendations</ion-card-title>
              <div class="pagination-info" *ngIf="recommendations.length > 0">
                <ion-text color="medium">
                  {{ recommendations.length }} recommendations
                </ion-text>
              </div>
            </div>
          </ion-card-header>

          <ion-card-content class="no-padding">
            <!-- Loading State -->
            <div *ngIf="isLoadingRecommendations" class="loading-state">
              <ion-spinner></ion-spinner>
              <p>Loading recommendations...</p>
            </div>

            <!-- Error State -->
            <div
              *ngIf="
                error &&
                !isLoadingRecommendations &&
                currentTab === 'recommendations'
              "
              class="error-state"
            >
              <ion-icon name="alert-circle" color="danger"></ion-icon>
              <p>{{ error }}</p>
              <ion-button fill="outline" (click)="onRefresh()"
                >Try Again</ion-button
              >
            </div>

            <!-- Recommendations List -->
            <div
              *ngIf="
                !isLoadingRecommendations &&
                !error &&
                recommendations.length > 0
              "
            >
              <ion-card
                *ngFor="let recommendation of recommendations"
                class="recommendation-card"
                button
                (click)="viewRecommendationDetail(recommendation.id)"
              >
                <ion-card-header>
                  <ion-card-title>{{ recommendation.category }}</ion-card-title>
                  <ion-card-subtitle>
                    {{
                      recommendation.recommendationType === "create"
                        ? "Create New Article"
                        : "Update Existing Article"
                    }}
                    <span *ngIf="recommendation.existingArticleTitle">
                      - {{ recommendation.existingArticleTitle }}
                    </span>
                  </ion-card-subtitle>
                </ion-card-header>
                <ion-card-content>
                  <p>
                    {{ getTotalConversationCount(recommendation.insights) }}
                    conversations across
                    {{ recommendation.insights.length }} insights
                  </p>

                  <ul>
                    <li
                      *ngFor="
                        let insight of recommendation.insights.slice(0, 5)
                      "
                    >
                      {{ insight.conversationCount }} conversations ({{
                        insight.language
                      }})
                    </li>
                    <li *ngIf="recommendation.insights.length > 5">
                      +{{ recommendation.insights.length - 5 }} more insights
                    </li>
                  </ul>

                  <div
                    *ngIf="recommendation.createdAt || recommendation.ignoredAt"
                  >
                    <ion-text color="medium">
                      <small>
                        <span *ngIf="recommendation.createdAt">
                          Created {{ formatDate(recommendation.createdAt) }}
                        </span>
                        <span *ngIf="recommendation.ignoredAt">
                          • Ignored {{ formatDate(recommendation.ignoredAt) }}
                        </span>
                      </small>
                    </ion-text>
                  </div>
                </ion-card-content>
              </ion-card>
            </div>

            <!-- Empty State for Recommendations -->
            <div
              *ngIf="
                !isLoadingRecommendations &&
                !error &&
                recommendations.length === 0 &&
                currentTab === 'recommendations'
              "
              class="empty-state"
            >
              <ion-icon
                name="bulb-outline"
                size="large"
                color="medium"
              ></ion-icon>
              <h3>No Recommendations Found</h3>
              <p>
                No knowledge gap recommendations are available for this tenant.
              </p>
            </div>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>

    <!-- Insights List -->
    <ion-row *ngIf="currentTab === 'insights'">
      <ion-col>
        <ion-card>
          <ion-card-header>
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <ion-card-title>Detection Insights</ion-card-title>
              <div class="pagination-info" *ngIf="totalInsights > 0">
                <ion-text color="medium">
                  {{ (currentPage - 1) * pageSize + 1 }}-{{ getEndRange() }} of
                  {{ totalInsights }}
                </ion-text>
              </div>
            </div>
          </ion-card-header>

          <ion-card-content class="no-padding">
            <!-- Loading State -->
            <div *ngIf="isLoadingInsights" class="loading-state">
              <ion-spinner></ion-spinner>
              <p>Loading insights...</p>
            </div>

            <!-- Error State -->
            <div
              *ngIf="error && !isLoadingInsights && currentTab === 'insights'"
              class="error-state"
            >
              <ion-icon name="alert-circle" color="danger"></ion-icon>
              <p>{{ error }}</p>
              <ion-button fill="outline" (click)="onRefresh()"
                >Try Again</ion-button
              >
            </div>

            <!-- Insights List -->
            <div *ngIf="!isLoadingInsights && !error && insights?.length > 0">
              <ion-card
                *ngFor="let insight of insights"
                class="insight-card"
                button
                (click)="viewInsightDetail(insight.id)"
              >
                <ion-card-header>
                  <ion-card-title>{{ insight.category }}</ion-card-title>
                  <ion-card-subtitle>
                    {{ insight.topics?.length || 0 }} topics detected
                  </ion-card-subtitle>
                </ion-card-header>
                <ion-card-content>
                  <p *ngIf="insight.topics?.length">
                    {{ getUniqueConversationCount(insight.topics) }}
                    conversations detected for this category
                  </p>

                  <ul *ngIf="insight.topics?.length; else noTopics">
                    <li *ngFor="let topic of insight.topics.slice(0, 5)">
                      <strong>{{ topic.topicTitle }}</strong>
                      <small *ngIf="topic.confidence">
                        - {{ topic.confidence * 100 | number: "1.0-0" }}%
                        confidence</small
                      >
                      <div
                        *ngIf="topic.topicDescription"
                        style="margin-top: 0.25rem"
                      >
                        <small style="color: var(--ion-color-medium)">{{
                          topic.topicDescription
                        }}</small>
                      </div>
                    </li>
                    <li *ngIf="insight.topics.length > 5">
                      +{{ insight.topics.length - 5 }} more topics
                    </li>
                  </ul>

                  <ng-template #noTopics>
                    <p><em>No topics available for this insight</em></p>
                  </ng-template>

                  <div *ngIf="insight.createdAt">
                    <ion-text color="medium">
                      <small>
                        Created {{ formatDate(insight.createdAt) }}
                      </small>
                    </ion-text>
                  </div>
                </ion-card-content>
              </ion-card>
            </div>

            <!-- Empty State -->
            <div
              *ngIf="
                !isLoadingInsights &&
                !error &&
                (!insights || insights.length === 0) &&
                currentTab === 'insights'
              "
              class="empty-state"
            >
              <ion-card>
                <ion-card-content class="ion-text-center">
                  <ion-icon
                    name="analytics-outline"
                    size="large"
                    color="medium"
                  ></ion-icon>
                  <h3>No Insights Available</h3>
                  <p>No knowledge gap insights found. This could mean:</p>
                  <ul>
                    <li>No analysis has been run yet</li>
                    <li>No patterns were detected in conversations</li>
                    <li>
                      Try running the "Trigger Analysis" to generate insights
                    </li>
                  </ul>
                  <ion-button
                    fill="outline"
                    (click)="clearFilters()"
                    *ngIf="selectedCategory"
                  >
                    Clear Filters
                  </ion-button>
                </ion-card-content>
              </ion-card>
            </div>

            <!-- Pagination -->
            <div *ngIf="totalInsights > pageSize" class="pagination-container">
              <ion-button
                fill="clear"
                [disabled]="!hasPreviousPage"
                (click)="previousPage()"
              >
                <ion-icon name="chevron-back" slot="start"></ion-icon>
                Previous
              </ion-button>

              <span class="page-info">
                Page {{ currentPage }} of {{ getTotalPages() }}
              </span>

              <ion-button
                fill="clear"
                [disabled]="!hasNextPage"
                (click)="nextPage()"
              >
                Next
                <ion-icon name="chevron-forward" slot="end"></ion-icon>
              </ion-button>
            </div>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>

  <!-- Insight Detail Modal -->
  <ion-modal
    [isOpen]="!!selectedInsight"
    (didDismiss)="clearInsightSelection()"
  >
    <ng-template>
      <ion-header>
        <ion-toolbar>
          <ion-title>Insight Details</ion-title>
          <ion-buttons slot="end">
            <ion-button (click)="clearInsightSelection()">
              <ion-icon name="close"></ion-icon>
            </ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>

      <ion-content *ngIf="selectedInsight">
        <div class="insight-detail">
          <ion-card>
            <ion-card-header>
              <ion-card-title>{{ selectedInsight.topic }}</ion-card-title>
              <ion-card-subtitle>{{
                selectedInsight.category
              }}</ion-card-subtitle>
            </ion-card-header>

            <ion-card-content>
              <ion-grid>
                <ion-row>
                  <ion-col size="6" *ngIf="selectedInsight.confidenceScore">
                    <h5>Confidence Score</h5>
                    <ion-text
                      [color]="
                        getConfidenceColor(selectedInsight.confidenceScore)
                      "
                    >
                      <h2>
                        {{
                          selectedInsight.confidenceScore * 100
                            | number: "1.1-1"
                        }}%
                      </h2>
                    </ion-text>
                  </ion-col>
                </ion-row>

                <ion-row *ngIf="selectedInsight.relatedTopics?.length">
                  <ion-col>
                    <h5>Related Topics</h5>
                    <div class="topics-list">
                      <ion-chip
                        *ngFor="let topic of selectedInsight.relatedTopics"
                        color="primary"
                        outline
                      >
                        {{ topic }}
                      </ion-chip>
                    </div>
                  </ion-col>
                </ion-row>

                <ion-row>
                  <ion-col>
                    <h5>Metadata</h5>
                    <ion-list>
                      <ion-item
                        *ngIf="selectedInsight.metadata?.conversationCount"
                      >
                        <ion-label>Conversation Count</ion-label>
                        <ion-note slot="end">{{
                          selectedInsight.metadata.conversationCount
                        }}</ion-note>
                      </ion-item>
                      <ion-item
                        *ngIf="selectedInsight.metadata?.avgResponseTime"
                      >
                        <ion-label>Average Response Time</ion-label>
                        <ion-note slot="end"
                          >{{
                            selectedInsight.metadata.avgResponseTime
                          }}s</ion-note
                        >
                      </ion-item>
                      <ion-item *ngIf="selectedInsight.metadata?.userFeedback">
                        <ion-label>User Feedback</ion-label>
                        <ion-chip
                          [color]="
                            selectedInsight.metadata.userFeedback === 'positive'
                              ? 'success'
                              : selectedInsight.metadata.userFeedback ===
                                  'negative'
                                ? 'danger'
                                : 'medium'
                          "
                          slot="end"
                          size="small"
                        >
                          {{ selectedInsight.metadata.userFeedback }}
                        </ion-chip>
                      </ion-item>
                    </ion-list>
                  </ion-col>
                </ion-row>

                <ion-row *ngIf="selectedInsight.metadata?.patterns?.length">
                  <ion-col>
                    <h5>Patterns</h5>
                    <ul>
                      <li
                        *ngFor="
                          let pattern of selectedInsight.metadata.patterns
                        "
                      >
                        {{ pattern }}
                      </li>
                    </ul>
                  </ion-col>
                </ion-row>

                <ion-row>
                  <ion-col>
                    <h5>Created</h5>
                    <p>{{ formatDateTime(selectedInsight.createdAt) }}</p>
                  </ion-col>
                </ion-row>

                <ion-row *ngIf="selectedInsight.recommendationId">
                  <ion-col>
                    <ion-button
                      expand="block"
                      fill="outline"
                      (click)="
                        viewRecommendation(selectedInsight.recommendationId!)
                      "
                    >
                      <ion-icon name="arrow-forward" slot="start"></ion-icon>
                      View Recommendation
                    </ion-button>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </ion-card-content>
          </ion-card>
        </div>
      </ion-content>
    </ng-template>
  </ion-modal>

  <!-- Recommendation Detail Modal -->
  <ion-modal
    [isOpen]="!!selectedRecommendation"
    (didDismiss)="clearRecommendationSelection()"
  >
    <ng-template>
      <ion-header>
        <ion-toolbar>
          <ion-title>Recommendation Details</ion-title>
          <ion-buttons slot="end">
            <ion-button (click)="clearRecommendationSelection()">
              <ion-icon name="close"></ion-icon>
            </ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>

      <ion-content *ngIf="selectedRecommendation">
        <div class="recommendation-detail">
          <ion-card>
            <ion-card-header>
              <ion-card-title>{{
                selectedRecommendation.category
              }}</ion-card-title>
              <ion-card-subtitle>
                <ion-chip
                  [color]="
                    getRecommendationTypeColor(
                      selectedRecommendation.recommendationType
                    )
                  "
                  size="small"
                >
                  <ion-icon
                    [name]="
                      getRecommendationTypeIcon(
                        selectedRecommendation.recommendationType
                      )
                    "
                    size="small"
                  ></ion-icon>
                  {{
                    selectedRecommendation.recommendationType === "create"
                      ? "Create New Article"
                      : "Update Existing Article"
                  }}
                </ion-chip>
              </ion-card-subtitle>
            </ion-card-header>

            <ion-card-content>
              <ion-grid>
                <ion-row *ngIf="selectedRecommendation.existingArticleTitle">
                  <ion-col>
                    <h5>Existing Article</h5>
                    <p>{{ selectedRecommendation.existingArticleTitle }}</p>
                  </ion-col>
                </ion-row>

                <ion-row *ngIf="selectedRecommendation.insights.length > 0">
                  <ion-col>
                    <h5>Related Insights</h5>
                    <ion-list>
                      <ion-item
                        *ngFor="let insight of selectedRecommendation.insights"
                      >
                        <ion-label>
                          <h3>
                            {{ insight.category }} ({{ insight.language }})
                          </h3>
                          <p>
                            {{ insight.topicCount }} topics,
                            {{ insight.conversationCount }} conversations
                          </p>
                          <ion-text color="medium">
                            <small
                              >Created
                              {{ formatDate(insight.createdAt) }}</small
                            >
                          </ion-text>
                        </ion-label>
                      </ion-item>
                    </ion-list>
                  </ion-col>
                </ion-row>

                <ion-row>
                  <ion-col>
                    <h5>Created</h5>
                    <p>
                      {{ formatDateTime(selectedRecommendation.createdAt) }}
                    </p>
                  </ion-col>
                </ion-row>

                <ion-row *ngIf="selectedRecommendation.ignoredAt">
                  <ion-col>
                    <h5>Status</h5>
                    <ion-chip color="medium" size="small">
                      <ion-icon name="eye-off" size="small"></ion-icon>
                      Ignored at
                      {{ formatDateTime(selectedRecommendation.ignoredAt) }}
                    </ion-chip>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </ion-card-content>
          </ion-card>
        </div>
      </ion-content>
    </ng-template>
  </ion-modal>
</ion-content>
